function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20,8L20,16C20,17.104 19.104,18 18,18L6,18C4.896,18 4,17.104 4,16L4,8C4,6.896 4.896,6 6,6L18,6C19.104,6 20,6.896 20,8Z",
    style: {
      fill: "none",
      stroke: "rgb(154,154,154)",
      strokeWidth: "1.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,7.5L12,12.5L18.5,7.5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(154,154,154)",
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesNormal);
export default __webpack_public_path__ + "static/media/messages_normal.ede570dc0c2d5e6b4662fa6b8642a030.svg";
export { ForwardRef as ReactComponent };